module.exports = __webpack_public_path__ + "static/img/ziyou02.d107c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ziyou02.png
// module id = 6Ch1
// module chunks = 1